export default __webpack_public_path__ + "static/media/toggle-white.0b5c2402.svg";